import { createAction, props } from '@ngrx/store';
import { Theme } from '../../models';

export const LoadThemes = createAction('[Themes] Load Themes');
export const LoadThemesSuccess = createAction('[Themes] Load Themes Success', props<{ themes: Theme[] }>());
export const LoadThemesFail = createAction('[Themes] Load Themes Fail', props<{ error: any }>());
